import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Layout.css';

const Header = () => {
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const isLocalEnv = process.env.REACT_APP_API_URL && 
                     process.env.REACT_APP_API_URL.includes('localhost');

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <span className="logo-icon">🔐</span>
            <span className="logo-text">zkVox</span>
            {isLocalEnv && <span className="env-badge">LOCAL</span>}
          </Link>
          
          <nav className="main-nav">
            <ul className="nav-list">
              <li className="nav-item">
                <Link to="/" className={`nav-link ${isActive('/')}`}>Home</Link>
              </li>
              <li className="nav-item">
                <Link to="/elections" className={`nav-link ${isActive('/elections')}`}>Elections</Link>
              </li>
              <li className="nav-item">
                <Link to="/elections/create" className={`nav-link ${isActive('/elections/create')}`}>Create Election</Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;